// extracted by mini-css-extract-plugin
export default {"contactListMobile":"contact-list-mobile_contactListMobile__5l5R5"};